export const dogsAndCatsColors = [
    "Black",
    "White",
    "Blue",
    "Brown",
    "Chocolate", 
    "Cinnamon",
    "Fawn",
    "Yellow",
    "Cream",
    "Gold",
    "Grey",
    "Red",
    "Lilac"
]

export const generalColors = [
    "Black",
    "White",
    "Blue",
    "Brown",
    "Chocolate",
    "Cinnamon",
    "Fawn",
    "Yellow",
    "Cream",
    "Gold",
    "Grey",
    "Red",
    "Lilac",
    "Orange",
    "Yellow",
    "Green",
    "Purple",
    "Pink"
]